<template>
  <div class="registerObj" style="padding: 0 1em; text-align: left;">
    <div style="padding: 3em 5em; width: 50%;"
      v-if="status == 2">
      <el-form :model="form" ref="ruleForm" :rules="rules" label-width="100px">
        <el-form-item label="輸入帳號：" prop="id">
          <el-input type="text" v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item label="輸入新密碼：" prop="newPsd1">
          <el-input type="password" v-model="form.newPsd1"></el-input>
        </el-form-item>
        <el-form-item label="確認新密碼：" prop="newPsd2">
          <el-input type="password" v-model="form.newPsd2"></el-input>
        </el-form-item>
        <el-form-item label="" style="text-align:left; line-height: 2em; color: purple;">
          *密碼強度需求等級：中<br />
          *密碼最少須有8字元以上
        </el-form-item>
        <el-form-item label="密碼強度偵測" style="text-align:left; margin-left: 120px;" v-show="pwStrength>0">
          <span v-if="pwStrength==1" style="border-color: #FF0000; font-size: larger;">弱</span>
          <span v-else-if="pwStrength==2" style="border-color: #FF9900; font-size: larger;">中</span>
          <span v-else-if="pwStrength>2" style="border-color: #33CC00; font-size: larger;">強</span>
          <span v-else style="border-color: #eeeeee;">密碼強度偵測</span>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="register('ruleForm')"><i class="el-icon-check"></i>&nbsp;{{$t('message.Save_cmd')}}</el-button>
        </el-form-item>
      </el-form>
      <br/>
      <div class="text-right pl-1 pr-1" style="margin: 1em 0 0;">
        <a href="#" class="btn btn-link btn-lg"
          @click.prevent="setStatus(0)">已經註冊，請點我回<b style="font-size:larger">帳號登入</b>!</a>
      </div>
    </div>
    <div style="padding: 5em 3em;"
      v-else>
      <form class="form_login" method="post">
        <table cellspacing="0" style="border: 0; margin: 0 0 0.4em 0;">
          <tbody>
            <tr>
              <td style="height: 3em; width: 100px;text-align:right;">{{$t('message.ID_txt')}}：</td>
              <td style="text-align:left; vertical-align: top;" colspan="2">
                <el-input class="input-205" placeholder="請輸入身分證字號" maxlength="20" tabindex="1" style="width:9.375em;"
                  v-model="user.id1"></el-input>
              </td>
            </tr>
            <tr>
              <td style="height: 3em; text-align:right;">{{$t('message.PassW_txt')}}：</td>
              <td style="text-align:left; vertical-align: top;" colspan="2">
                <el-input class="input-205" type="password" maxlength="20" placeholder="請輸入密碼" tabindex="2" style="width:9.375em;"
                  v-model="user.id2"></el-input>
              </td>
            </tr>
            <tr>
              <td style="height: 3em; text-align:right;">{{$t('message.ValiC_txt')}}：</td>
              <td style="text-align: left; vertical-align: top; width: 100px;">
                <el-input class="input-205" placeholder="請輸入驗證碼" maxlength="6" tabindex="3" style="width:9.375em;"
                  v-model="user.id3"></el-input>
              </td>
              <td style="display:flex; padding: 0.3em;">
                <img v-if="captchaInfo != null" :src="captchaInfo" style="margin: 0 0 0 0; height: 2.25em;" alt=""/>
                  <a href="#" style="padding: 5px 0.6em;" title="重新產生驗證碼" tabindex="4"  @click.prevent="getCaptcha()">
                    <i class="el-icon-refresh"></i>
                  </a>
              </td>
            </tr>
            <tr>
              <td></td>
              <td style="padding: 2em 0.5em;" colspan="2">
                <el-button type="primary" tabindex="5" @click.prevent="login()">
                  <span class="glyphicon glyphicon-log-in" style="margin-right: 4px;"></span> {{$t('message.Sign_in')}}
                </el-button>
              </td>
            </tr>
            <tr>
              <td style="padding: 2em;" colspan="3">
                <!--<div class="text-right pl-1 pr-1" style="margin: 1em 0 0;">
                  <a href="#" class="btn btn-link btn-lg"
                    @click.prevent="setStatus(2)">第一次進入，請點我<b style="font-size:larger">註冊帳號</b>!</a>
                </div>-->
              </td>
            </tr>
          </tbody>
        </table>
      </form>      
    </div>
  </div>
</template>

<script>
import * as tools from '../tool';
export default {
  name: 'registerObj',
  data () {
    return {
      user: {
        gId: 0,
        id1: '',
        id2: '',
        id3: '',
        isLogin: true
      },
      status: 0,
      captchaInfo: null,
      pwStrength: 0,
      form: {
        id: '',
        newPsd1: '',
        newPsd2: ''
      },
      rules: {
        id:[{validator: (rule, value, callback) => {
          if (!value || value === '') {
            callback(new Error('請輸入帳號'))
          } else {
            callback()
          }
        },trigger:"blur"},
        { min: 6, max: 20, message: '長度在 6 到 20 個字元', trigger: 'blur' }],
        newPsd1:[{validator: (rule, value, callback) => {
          if (!value || value === '') {
            callback(new Error('請設定密碼'))
          } else {
            if (this.form.newPsd2 !== '') {
              this.$refs.ruleForm.validateField('newPsd2')
            }
            callback()
          }
        } ,trigger:"blur"},
        { min: 8, max: 20, message: '長度在 8 到 20 個字元', trigger: 'blur' }],
        newPsd2:[{validator: (rule, value, callback) => {
          if (!value || value === '') {
            callback(new Error('請確認新密碼'))
          } else if (value !== this.form.newPsd1) {
            callback(new Error('兩次輸入密碼不一致!'))
          } else if (tools.checkStrong(value) < 2) {
            callback(new Error('密碼強度不足!'))
          } else {
            callback()
          }
        },trigger:"blur"},
        { validator: (rule, value, callback) => {    
          this.pwStrength = tools.checkStrong(value)
          if (this.pwStrength < 2) {
            callback(new Error('密碼強度不足!'))
          } else {
            callback()
          }
        },trigger:"change"}]
      }
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId;
    },
    setting () {
      return this.$store.getters.getSetting;
    }
  },
  methods: {
    setStatus: function (flag) {
      this.status = flag;
    },
    register (ruleForm) {
      this.$refs.ruleForm.validate((valid) => {
        console.log('======register ===== valid:' + valid)
        if (valid) {
          let pData = {
            eId: this.setting.enrollID[0].codeName,
            text1: this.form.id,
            text2: this.form.newPsd1
          }
          this.$http.put('./WebApi/Apply/SetRegisterData', pData)
            .then((response) => {
              switch (response.data) {
                case 1:
                  this.$message({
                    message: '恭喜您,存檔成功',
                    type: 'success'
                  });
                  this.setStatus(0);
                  break;
                case -2:
                  this.$message.error('對不起,這個帳號已經註冊,請重新輸入!!')
                  break;
                default:
                  this.$message.error('對不起,存檔失敗')
                  break;
              }
            })
            .catch(function (error) {
              this.$message.error('對不起,網路連線失敗' + error)
            })
        } else {
          this.$message.error('對不起,驗證失敗')
          return false
        }
      })
    },
    login: function () {
      var vm = this
      this.$http.put('./WebApi/Common/SignIn', this.user)
        .then((response) => {
          var tmpData = response.data;
          console.log(response);
          console.log(tmpData);
          if (tmpData != null) {
            if(tmpData.locked){
                vm.$message.error('警告!!本帳號已被鎖定，請稍後再使用。')
                vm.user.id1 = ''
                vm.user.id2 = ''
                return;
            }
            if(tmpData.usrData.id === vm.user.id1){
                console.log('set Authorized' + tmpData.usrData.id)
                var usrData = tmpData.usrData
                vm.$store.dispatch('actionLogin', usrData)
                vm.user.id1 = ''
                vm.user.id2 = ''
                vm.user.id3 = ''
                this.$emit('getDefaultMenu', vm.sysId, false)
            }
            
          } else {
            vm.$message.error('請檢查帳號密碼是否輸入正確')
            vm.user.id1 = ''
            vm.user.id2 = ''
          }
        })
        .catch(function (error) {
          vm.$message.error('對不起,網路連線失敗' + error)
        })
    },
    getCaptcha: function () {
      var vm = this
      this.$http
        .get('./WebApi/Tools/GetCaptcha/')
        .then(function (response) {
          vm.captchaInfo = response.data
        })
        .catch(function (error) {
          vm.$message.error('對不起,網路連線失敗' + error)
        })
    },
  },
  created () {
    console.log('======RegisterView=====');
    this.getCaptcha();
    this.user.gId = this.setting.enrollID[0].codeName;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/RegisterView.vue